import React, { Component } from "react";
import {
  Row,
  Col,
  Form,
  Button,
  Card,
  Input,
  message,
  Radio,
  Spin,
  Tag,
  Collapse,
} from "antd";

import { Link } from "react-router-dom";
import CurrencyFormat from "react-currency-format";
import { connect } from "react-redux";
import ModalCreateSPK from "./Modal/ModalCreateSPK";
import ModalConfirmation from "./Modal/ModalConfirmation";
import ModalDialog from "./Modal/ModalDialog";
import ModalRejectApproval from "./Modal/ModalRejectApproval";
import Axios from "axios";
import axios from "../../../services/axios";
import {
  errorMessage,
  formatRupiah,
  getIntegerValueByKey,
  getFloatValueByKey,
} from "../../Utils";
import moment from "moment-timezone";
import ModalValidationSPK from "./Modal/ModalValidationSPK";
import _ from "lodash";

import CarInformation from "./Section/CarInformation";
import AuditTrail from "./Section/AuditTrail";
import AccumulatedGP from "./Section/AccumulatedGP";

const FormItem = Form.Item;
let cancelToken;

const defaultPayload = {
  requestType: "Approved",
  isUnitKinto: false,
  mobilisasiUnit: {
    odooPrice: 0,
    trustPrice: 0,
    priceTotal: 0,
  },
  salesCommission: {
    odooPrice: 0,
    trustPrice: 0,
    priceTotal: 0,
  },
  isSourchingFee: false,
  isSellingFee: false,
  lelang: {
    odooPrice: 0,
    trustPrice: 0,
    priceTotal: 0,
  },
  generalRepair: {
    odooPrice: 0,
    trustPrice: 0,
    priceTotal: 0,
  },
  bodyRepair: {
    odooPrice: 0,
    trustPrice: 0,
    priceTotal: 0,
  },
  biayaPajakSTNK: {
    odooPrice: 0,
    trustPrice: 0,
    priceTotal: 0,
  },
  bbmStockUnit: {
    odooPrice: 0,
    trustPrice: 0,
    priceTotal: 0,
  },
  others: {
    odooPrice: 0,
    trustPrice: 0,
    priceTotal: 0,
  },
  discount: { priceTotal: 0, discount: 0 },
  discountSubsidiDP: { priceTotal: 0, discount: 0 },
  approvalDiscount: 0,
  unitPurchase: 0,
  unitKinto: 0,
  sourchingFee: 0,
  sellingFee: 0,
  totalCost: 0,
  profit: { priceTotal: 0, profitPercent: 0 },
  mSourcingFeePercent: 1.5,
  mSellingFeePercent: 1.5,
  mUnitKintoPercent: 11,
  mProfitPercent: 5,
};

class EApprovalBOHDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      showModal: false,
      showModalConfirmation: false,
      showModalValidation: false,
      showModalDialog: false,
      showModalReject: false,
      isDefault: true,
      isPPN: true,
      isSourcing: false,
      isSelling: false,
      profit: 5,
      modalCaption: "",
      rawData: null,
      payload: defaultPayload,
      isAgree: null,
      dataAccumulated: {
        bohAccumulated: 0,
        gmAccumulated: 0,
        totalAccumulated: 0,
      },
    };
  }

  componentDidMount() {
    const { history } = this.props;
    this.fetchData(history.location.state.id);
  }

  async fetchData(id) {
    this.setState({ isLoading: true });
    if (cancelToken) {
      cancelToken.cancel("Operation canceled due to new request");
    }
    cancelToken = Axios.CancelToken.source();

    await axios
      .get(`car-sales/${id}`)
      .then((result) => {
        this.setState({
          rawData: result.data.carSale,
          isAgree: result.data.carSale.isAgree,
          isDefault: result.data.carSale.isAgree ? false : true,
          isLoading: false,
        });

        if (result.data) {
          this.convertDataCalculationDetail(result.data.carSale);
          this.getAccumulateData(id);
        }
      })
      .catch((err) => {
        if (!Axios.isCancel(err)) {
          errorMessage(err.response || err);
          this.setState({ isLoading: false });
        }
      });
  }

  async getAccumulateData(id) {
    if (cancelToken) {
      cancelToken.cancel("Operation canceled due to new request");
    }
    cancelToken = Axios.CancelToken.source();

    await axios
      .get(`car-sales/${id}/accumulated`)
      .then((result) => {
        this.setState({ dataAccumulated: result.data });
      })
      .catch((err) => {
        if (!Axios.isCancel(err)) {
          errorMessage(err.response || err);
        }
      });
  }

  convertDataCalculationDetail = (datas) => {
    let { payload } = this.state;

    payload.mSourcingFeePercent = datas.mSourcingFeePercent || 1.5;
    payload.mSellingFeePercent = datas.mSellingFeePercent || 1.5;
    payload.mUnitKintoPercent = datas.mUnitKintoPercent || 11;
    payload.mProfitPercent = datas.mProfitPercent || 5;

    datas.calculationDetail &&
      datas.calculationDetail.map((item) => {
        switch (item.name) {
          case "OTR":
            payload.otr = item.priceTotal;
            break;
          case "Sales Revenue":
            payload.salesRevenue = item.priceTotal;
            break;
          case "DPP":
            payload.dpp = item.priceTotal;
            break;
          case "Unit Purchase":
            payload.unitPurchase = item.priceTotal;
            break;
          case "Unit Kinto PPN":
            payload.unitKintoData = item;
            payload.unitKinto = item.isStatus ? item.priceTotal : 0;
            payload.isUnitKinto = item.isStatus ? 1 : 0;
            break;
          case "Mobilisasi Unit":
            payload.mobilisasiUnit = item;
            break;
          case "Sales Commission":
            payload.salesCommission = item;
            break;
          case "Sourching Fee":
            payload.sourchingFeeData = item;
            payload.sourchingFee = item.isStatus ? item.priceTotal : 0;
            payload.isSourchingFee =
              datas.isAgree || datas.status !== "New"
                ? item.isStatus
                  ? 1
                  : 0
                : null;
            break;
          case "Selling Fee":
            payload.sellingFeeData = item;
            payload.sellingFee = item.isStatus ? item.priceTotal : 0;
            payload.isSellingFee =
              datas.isAgree || datas.status !== "New"
                ? item.isStatus
                  ? 1
                  : 0
                : null;
            break;
          case "Lelang":
            payload.lelang = item;
            break;
          case "General Repair":
            payload.generalRepair = item;
            break;
          case "Body Repair":
            payload.bodyRepair = item;
            break;
          case "Biaya Pajak STNK":
            payload.biayaPajakSTNK = item;
            break;
          case "BBM Stock Unit":
            payload.bbmStockUnit = item;
            break;
          case "Others":
            payload.others = item;
            break;
          case "Total Cost":
            payload.totalCost = item.priceTotal;
            break;
          case "Available Margin":
            payload.availableMargin = item.priceTotal;
            break;
          case "Discounts - Subsidi DP":
            payload.discountSubsidiDP = item;
            break;
          case "Discounts":
            payload.discount = item;
            break;
          case "Profit":
            payload.profit = item;
            break;
          case "Kilometer":
            payload.kilometer = item.value;
            break;
          case "Stock Days":
            payload.stockDays = item.value;
            break;
          default:
            break;
        }
      });

    this.setState({
      isSourcing: datas.isAgree || datas.status !== "New",
      isSelling: datas.isAgree || datas.status !== "New",
      payload,
    });
  };

  calculateData = (type, value) => {
    let values = !isNaN(value) ? value : 0;
    let payload = Object.assign([], this.state.payload);
    let radioField = ["unitKinto", "sourchingFee", "sellingFee"];
    if (radioField.includes(type)) {
      payload[type] = values;
    } else if (type === "discountSubsidiDP") {
      payload[type] = {
        ...payload.discountSubsidiDP,
        priceTotal: values,
        discount: parseFloat(((values / payload.dpp) * 100).toFixed(2)),
      };
    } else {
      payload[type] = {
        ...payload[type],
        trustPrice: values,
        priceTotal: payload[type].odooPrice + values,
      };
    }
    let {
      dpp,
      profit,
      unitPurchase,
      unitKinto,
      mobilisasiUnit,
      salesCommission,
      sourchingFee,
      sellingFee,
      lelang,
      generalRepair,
      bodyRepair,
      biayaPajakSTNK,
      bbmStockUnit,
      others,
      discountSubsidiDP,
    } = payload;

    let totalCost =
      unitPurchase +
      unitKinto +
      mobilisasiUnit.priceTotal +
      salesCommission.priceTotal +
      sourchingFee +
      sellingFee +
      lelang.priceTotal +
      generalRepair.priceTotal +
      bodyRepair.priceTotal +
      biayaPajakSTNK.priceTotal +
      bbmStockUnit.priceTotal +
      others.priceTotal;

    let availableMargin = dpp - totalCost;
    let priceTotal = availableMargin - discountSubsidiDP.priceTotal;
    let profitPercent = parseFloat(((priceTotal / dpp) * 100).toFixed(2));
    if (dpp == 0) profitPercent = 0;

    this.setState({
      payload: {
        ...payload,
        totalCost,
        availableMargin,
        profit: { ...profit, profitPercent, priceTotal },
      },
    });
  };

  convertPayloadRequest(payload) {
    return {
      isAgree: payload.isAgree,
      isUnitKinto: payload.isUnitKinto === 1,
      mobilisasiUnit: getIntegerValueByKey(
        payload,
        "mobilisasiUnit.trustPrice"
      ),
      salesCommission: getIntegerValueByKey(
        payload,
        "salesCommission.trustPrice"
      ),
      isSourchingFee: payload.isSourchingFee === 1,
      isSellingFee: payload.isSellingFee === 1,
      lelang: getIntegerValueByKey(payload, "lelang.trustPrice"),
      generalRepair: getIntegerValueByKey(payload, "generalRepair.trustPrice"),
      bodyRepair: getIntegerValueByKey(payload, "bodyRepair.trustPrice"),
      biayaPajakSTNK: getIntegerValueByKey(
        payload,
        "biayaPajakSTNK.trustPrice"
      ),
      bbmStockUnit: getIntegerValueByKey(payload, "bbmStockUnit.trustPrice"),
      others: getIntegerValueByKey(payload, "others.trustPrice"),
      discountSubsidiDP: getIntegerValueByKey(
        payload,
        "discountSubsidiDP.priceTotal"
      ),
    };
  }

  async handleAction(isAgree) {
    const { history } = this.props;
    let { payload, rawData } = this.state;
    let url = rawData && rawData.isAgree ? "boh-update" : "update-calculation";
    let payloads =
      rawData && rawData.isAgree
        ? {
            requestType:
              payload.profit.profitPercent <= payload.mProfitPercent
                ? "Request GM Approval"
                : "Approved",
          }
        : {
            ...this.convertPayloadRequest(payload),
            isAgree,
          };

    if (payload.profit.priceTotal) {
      await axios
        .patch(`/car-sales/${history.location.state.id}/${url}`, payloads)
        .then((result) => {
          // message.success(`Berhasil reject approval`);
          this.setState({
            showModalConfirmation: false,
            showModalDialog: true,
            modalCaption:
              rawData && rawData.isAgree
                ? payload.profit.profitPercent <= payload.mProfitPercent
                  ? "Request GM Approval Success"
                  : "Request Successfully Approved"
                : `Anda ${isAgree ? "" : "tidak"} menyetujui ${
                    isAgree
                      ? "bahwa rincian atas unit ini sudah sesuai"
                      : "rincian atas unit ini"
                  }`,
          });
          // this.props.history.push(`/home/e-approval/selling-system`);
        })
        .catch((err) => {
          if (!Axios.isCancel(err)) {
            errorMessage(err.response || err);
            this.setState({ isLoading: false });
          }
        });
    }

    if (rawData && rawData.status === "Approved") {
      this.setState({ showModal: true });
    }
  }

  callback(key, props) {
    props.form.resetFields();
  }

  defaultValueContent = (value) => {
    return (
      <Row>
        <Col span={2}></Col>
        <Col span={22}>
          <p style={{ margin: 0 }}>{formatRupiah(value)}</p>
        </Col>
      </Row>
    );
  };

  radioContent = (value, isStatus) => {
    const { rawData } = this.state;
    return (
      <Row>
        <Col span={2}></Col>
        <Col span={22}>
          <Radio.Group
            style={{ margin: "5px 0" }}
            disabled={
              rawData
                ? rawData.isAgree || rawData.status !== "New"
                  ? true
                  : false
                : true
            }
            value={isStatus}
            onChange={(event) => this.handleRadio(event.target.value, value)}>
            <Radio value={1}>Yes</Radio>
            <Radio value={0}>No</Radio>
          </Radio.Group>
        </Col>
      </Row>
    );
  };

  handleRadio = (value, type) => {
    let { payload, rawData } = this.state;
    let unit_purchase = payload.unitPurchase ? payload.unitPurchase : 0;
    let salesRevenue = payload.salesRevenue ? payload.salesRevenue : 0;

    switch (type) {
      case "kinto":
        let unitKinto = parseInt(
          (unit_purchase * (payload.mUnitKintoPercent || 11)) / 100
        );
        this.setState(
          { payload: { ...payload, isUnitKinto: value }, isPPN: true },
          () => this.calculateData("unitKinto", value === 1 ? unitKinto : 0)
        );
        break;
      case "sourcing":
        let sourchingFee = parseInt(
          (unit_purchase * (payload.mSourcingFeePercent || 1.5)) / 100
        );
        this.setState(
          { payload: { ...payload, isSourchingFee: value }, isSourcing: true },
          () =>
            this.calculateData("sourchingFee", value === 1 ? sourchingFee : 0)
        );
        break;
      case "selling":
        let sellingFee = parseInt(
          (salesRevenue * (payload.mSellingFeePercent || 1.5)) / 100
        );
        this.setState(
          {
            payload: { ...payload, isSellingFee: value },
            isSelling: true,
            isDefault: false,
          },
          () => this.calculateData("sellingFee", value === 1 ? sellingFee : 0)
        );
        break;
      default:
        break;
    }
  };

  calculationDetail = () => {
    let { rawData, payload, isPPN, isSourcing, isSelling } = this.state;

    let isOperational = rawData && rawData.productType === "Operational";
    return isOperational ? (
      <div style={{ margin: "20px 0" }}>
        <div style={{ margin: 20 }}>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" span={12}>
              <div style={{ marginBottom: 5 }}>Discounts - Subsidi DP</div>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="gutter-row" span={8}>
                  <div style={{ display: "flex" }}>
                    <CurrencyFormat
                      style={{
                        border: "1px solid #d9d9d9",
                        borderRadius: 5,
                        width: "100%",
                        padding: "0 10px",
                      }}
                      value={getFloatValueByKey(
                        payload,
                        "discountSubsidiDP.discount"
                      )}
                      thousandSeparator={"."}
                      decimalSeparator={","}
                      disabled={true}
                      placeholder={"Diskon"}
                    />
                    <div style={{ padding: 10, marginLeft: -30 }}>%</div>
                  </div>
                </Col>
                <Col className="gutter-row" span={16}>
                  <div style={{ display: "flex" }}>
                    <div
                      style={{
                        padding: 10,
                        backgroundColor: "#f5f5f5",
                        borderRadius: "5px 0px 0px 5px",
                      }}>
                      Rp.
                    </div>
                    <CurrencyFormat
                      style={{
                        border: "1px solid #d9d9d9",
                        borderRadius: "0px 5px 5px 0px",
                        width: "100%",
                        padding: "0 10px",
                      }}
                      value={getIntegerValueByKey(
                        payload,
                        "discountSubsidiDP.priceTotal"
                      )}
                      thousandSeparator={"."}
                      decimalSeparator={","}
                      disabled={true}
                      placeholder={"00,00"}
                    />
                  </div>
                </Col>
              </Row>
            </Col>
            <Col className="gutter-row" span={12}>
              <div style={{ marginBottom: 5 }}>Discounts</div>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="gutter-row" span={8}>
                  <div style={{ display: "flex" }}>
                    <CurrencyFormat
                      style={{
                        border: "1px solid #d9d9d9",
                        borderRadius: 5,
                        width: "100%",
                        padding: "0 10px",
                      }}
                      value={getFloatValueByKey(payload, "discount.discount")}
                      thousandSeparator={"."}
                      decimalSeparator={","}
                      disabled={true}
                      placeholder={"7,88"}
                    />
                    <div style={{ padding: 10, marginLeft: -30 }}>%</div>
                  </div>
                </Col>
                <Col className="gutter-row" span={16}>
                  <div style={{ display: "flex" }}>
                    <div
                      style={{
                        padding: 10,
                        backgroundColor: "#f5f5f5",
                        borderRadius: "5px 0px 0px 5px",
                      }}>
                      Rp.
                    </div>
                    <CurrencyFormat
                      style={{
                        border: "1px solid #d9d9d9",
                        borderRadius: "0px 5px 5px 0px",
                        width: "100%",
                        padding: "0 10px",
                      }}
                      value={getIntegerValueByKey(
                        payload,
                        "discount.priceTotal"
                      )}
                      thousandSeparator={"."}
                      decimalSeparator={","}
                      disabled={true}
                      placeholder={"17.000.000"}
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        <FormItem label="Sales Notes" style={{ marginBottom: 0 }}>
          <p>{rawData ? rawData.salesNotes : "-"}</p>
        </FormItem>
      </div>
    ) : (
      <div style={{ margin: "20px 0" }}>
        <h4>Cost:</h4>
        <div
          style={{
            borderRadius: 10,
            backgroundColor: "#EFF2F5",
            padding: 15,
          }}>
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="space-between"
            align="middle">
            <Col className="gutter-row" span={6}>
              <p style={{ marginBottom: 0 }}>Unit Purchase</p>
            </Col>
            <Col className="gutter-row" span={6}>
              {this.defaultValueContent(
                getIntegerValueByKey(payload, "unitPurchase")
              )}
            </Col>
            <Col className="gutter-row" span={6}>
              <p style={{ marginBottom: 0 }}> </p>
            </Col>
            <Col className="gutter-row" span={6}>
              <div style={{ textAlign: "right" }}>
                <p>
                  <CurrencyFormat
                    style={{ marginBottom: 0 }}
                    value={getIntegerValueByKey(payload, "unitPurchase")}
                    displayType={"text"}
                    decimalSeparator={","}
                    thousandSeparator={"."}
                    prefix={"Rp "}
                  />
                </p>
              </div>
            </Col>
          </Row>

          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="space-between"
            align="middle"
            style={{ display: "flex", alignItems: "center" }}>
            <Col className="gutter-row" span={6}>
              <p style={{ marginBottom: 0 }}>
                Unit Kinto (PPN) ({payload.mUnitKintoPercent}%)
              </p>
            </Col>
            <Col className="gutter-row" span={6}>
              {this.radioContent("kinto", payload.isUnitKinto)}
            </Col>
            <Col className="gutter-row" span={6}>
              <CurrencyFormat
                style={{
                  border: "1px solid #d9d9d9",
                  borderRadius: "5px",
                  width: "100%",
                  margin: "2px 0",
                }}
                value={getIntegerValueByKey(payload, "unitKinto")}
                thousandSeparator={"."}
                decimalSeparator={","}
                prefix={"Rp "}
                placeholder={"Rp 0"}
                disabled={true}
                onValueChange={(values) => {
                  const { formattedValue, value, floatValue } = values;
                  this.setState({
                    payload: {
                      ...payload,
                      unitKinto: floatValue,
                    },
                  });
                }}
              />
            </Col>
            <Col className="gutter-row" span={6}>
              <div style={{ textAlign: "right" }}>
                <p>
                  <CurrencyFormat
                    style={{
                      fontWeight: "normal",
                      marginBottom: 0,
                    }}
                    value={getIntegerValueByKey(payload, "unitKinto")}
                    displayType={"text"}
                    decimalSeparator={","}
                    thousandSeparator={"."}
                    prefix={"Rp "}
                  />
                </p>
              </div>
            </Col>
          </Row>

          {isPPN ? (
            <div>
              <Row
                gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                justify="space-between"
                align="middle"
                style={{ display: "flex", alignItems: "center" }}>
                <Col className="gutter-row" span={6}>
                  <p style={{ marginBottom: 0 }}>Mobilisasi Unit</p>
                </Col>
                <Col className="gutter-row" span={6}>
                  {this.defaultValueContent(
                    getIntegerValueByKey(payload, "mobilisasiUnit.odooPrice")
                  )}
                </Col>
                <Col className="gutter-row" span={6}>
                  <CurrencyFormat
                    style={{
                      border: "1px solid #d9d9d9",
                      borderRadius: "5px",
                      width: "100%",
                      margin: "2px 0",
                    }}
                    value={getIntegerValueByKey(
                      payload,
                      "mobilisasiUnit.trustPrice"
                    )}
                    thousandSeparator={"."}
                    decimalSeparator={","}
                    prefix={"Rp "}
                    placeholder={"Rp 0"}
                    disabled={
                      rawData
                        ? rawData.isAgree || rawData.status !== "New"
                          ? true
                          : false
                        : true
                    }
                    onValueChange={(values) => {
                      const { formattedValue, value, floatValue } = values;
                      this.calculateData("mobilisasiUnit", floatValue);
                    }}
                  />
                </Col>
                <Col className="gutter-row" span={6}>
                  <div style={{ textAlign: "right" }}>
                    <p>
                      <CurrencyFormat
                        style={{
                          fontWeight: "normal",
                          marginBottom: 0,
                        }}
                        value={getIntegerValueByKey(
                          payload,
                          "mobilisasiUnit.priceTotal"
                        )}
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        prefix={"Rp "}
                      />
                    </p>
                  </div>
                </Col>
              </Row>

              <Row
                gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                justify="space-between"
                align="middle"
                style={{ display: "flex", alignItems: "center" }}>
                <Col className="gutter-row" span={6}>
                  <p style={{ marginBottom: 0 }}>Sales Commision</p>
                </Col>
                <Col className="gutter-row" span={6}>
                  {this.defaultValueContent(
                    getIntegerValueByKey(payload, "salesCommission.odooPrice")
                  )}
                </Col>
                <Col className="gutter-row" span={6}>
                  <CurrencyFormat
                    style={{
                      border: "1px solid #d9d9d9",
                      borderRadius: "5px",
                      width: "100%",
                      margin: "2px 0",
                    }}
                    value={getIntegerValueByKey(
                      payload,
                      "salesCommission.trustPrice"
                    )}
                    thousandSeparator={"."}
                    decimalSeparator={","}
                    prefix={"Rp "}
                    placeholder={"Rp 0"}
                    disabled={
                      rawData
                        ? rawData.isAgree || rawData.status !== "New"
                          ? true
                          : false
                        : true
                    }
                    onValueChange={(values) => {
                      const { formattedValue, value, floatValue } = values;
                      this.calculateData("salesCommission", floatValue);
                    }}
                  />
                </Col>
                <Col className="gutter-row" span={6}>
                  <div style={{ textAlign: "right" }}>
                    <p>
                      <CurrencyFormat
                        style={{
                          fontWeight: "normal",
                          marginBottom: 0,
                        }}
                        value={getIntegerValueByKey(
                          payload,
                          "salesCommission.priceTotal"
                        )}
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        prefix={"Rp "}
                      />
                    </p>
                  </div>
                </Col>
              </Row>

              <Row
                gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                justify="space-between"
                align="middle"
                style={{ display: "flex", alignItems: "center" }}>
                <Col className="gutter-row" span={6}>
                  <p style={{ marginBottom: 0 }}>
                    Sourcing Fee ({payload.mSourcingFeePercent}%)
                  </p>
                </Col>
                <Col className="gutter-row" span={6}>
                  {this.radioContent("sourcing", payload.isSourchingFee)}
                </Col>
                <Col className="gutter-row" span={6}>
                  <CurrencyFormat
                    style={{
                      border: "1px solid #d9d9d9",
                      borderRadius: "5px",
                      width: "100%",
                      margin: "2px 0",
                    }}
                    value={getIntegerValueByKey(payload, "sourchingFee")}
                    thousandSeparator={"."}
                    decimalSeparator={","}
                    prefix={"Rp "}
                    placeholder={"Rp 0"}
                    disabled={true}
                    onValueChange={(values) => {
                      const { formattedValue, value, floatValue } = values;
                      this.calculateData("sourchingFee", floatValue);
                    }}
                  />
                </Col>
                <Col className="gutter-row" span={6}>
                  <div style={{ textAlign: "right" }}>
                    <p>
                      <CurrencyFormat
                        style={{
                          fontWeight: "normal",
                          marginBottom: 0,
                        }}
                        value={getIntegerValueByKey(payload, "sourchingFee")}
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        prefix={"Rp "}
                      />
                    </p>
                  </div>
                </Col>
              </Row>

              {isSourcing ? (
                <Row
                  gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                  justify="space-between"
                  align="middle"
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}>
                  <Col className="gutter-row" span={6}>
                    {isSourcing ? (
                      <p style={{ marginBottom: 0 }}>
                        Selling Fee ({payload.mSellingFeePercent}
                        %)
                      </p>
                    ) : null}
                  </Col>
                  <Col className="gutter-row" span={6}>
                    {isSourcing
                      ? this.radioContent("selling", payload.isSellingFee)
                      : null}
                  </Col>
                  <Col className="gutter-row" span={6}>
                    {isSourcing ? (
                      <CurrencyFormat
                        style={{
                          border: "1px solid #d9d9d9",
                          borderRadius: "5px",
                          width: "100%",
                          margin: "2px 0",
                        }}
                        value={getIntegerValueByKey(payload, "sellingFee")}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        prefix={"Rp "}
                        placeholder={"Rp 0"}
                        disabled={true}
                        onValueChange={(values) => {
                          const { formattedValue, value, floatValue } = values;
                          this.calculateData("sellingFee", floatValue);
                        }}
                      />
                    ) : null}
                  </Col>
                  <Col className="gutter-row" span={6}>
                    <div style={{ textAlign: "right" }}>
                      {isSourcing ? (
                        <p style={{ marginBottom: 0 }}>
                          <CurrencyFormat
                            value={getIntegerValueByKey(payload, "sellingFee")}
                            thousandSeparator={"."}
                            decimalSeparator={","}
                            prefix={"Rp "}
                            displayType={"text"}
                          />
                        </p>
                      ) : null}
                    </div>
                  </Col>
                </Row>
              ) : null}

              {isSelling ? (
                <div>
                  <Row
                    gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                    justify="space-between"
                    align="middle"
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}>
                    <Col className="gutter-row" span={6}>
                      <p style={{ marginBottom: 0 }}>Lelang</p>
                    </Col>
                    <Col className="gutter-row" span={6}>
                      {this.defaultValueContent(
                        getIntegerValueByKey(payload, "lelang.odooPrice")
                      )}
                    </Col>
                    <Col className="gutter-row" span={6}>
                      <CurrencyFormat
                        style={{
                          border: "1px solid #d9d9d9",
                          borderRadius: "5px",
                          width: "100%",
                          margin: "2px 0",
                        }}
                        value={getIntegerValueByKey(
                          payload,
                          "lelang.trustPrice"
                        )}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        prefix={"Rp "}
                        placeholder={"Rp 0"}
                        disabled={
                          rawData
                            ? rawData.isAgree || rawData.status !== "New"
                              ? true
                              : false
                            : true
                        }
                        onValueChange={(values) => {
                          const { formattedValue, value, floatValue } = values;
                          this.calculateData("lelang", floatValue);
                        }}
                      />
                    </Col>
                    <Col className="gutter-row" span={6}>
                      <div style={{ textAlign: "right" }}>
                        <p>
                          <CurrencyFormat
                            style={{ marginBottom: 0 }}
                            value={getIntegerValueByKey(
                              payload,
                              "lelang.priceTotal"
                            )}
                            displayType={"text"}
                            decimalSeparator={","}
                            thousandSeparator={"."}
                            prefix={"Rp "}
                          />
                        </p>
                      </div>
                    </Col>
                  </Row>
                  <Row
                    gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                    justify="space-between"
                    align="middle"
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}>
                    <Col className="gutter-row" span={6}>
                      <p style={{ margin: 0 }}>General Repair</p>
                    </Col>
                    <Col className="gutter-row" span={6}>
                      {this.defaultValueContent(
                        getIntegerValueByKey(payload, "generalRepair.odooPrice")
                      )}
                    </Col>
                    <Col className="gutter-row" span={6}>
                      <CurrencyFormat
                        style={{
                          border: "1px solid #d9d9d9",
                          borderRadius: "5px",
                          width: "100%",
                          margin: "2px 0",
                        }}
                        value={getIntegerValueByKey(
                          payload,
                          "generalRepair.trustPrice"
                        )}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        prefix={"Rp "}
                        placeholder={"Rp 0"}
                        disabled={
                          rawData
                            ? rawData.isAgree || rawData.status !== "New"
                              ? true
                              : false
                            : true
                        }
                        onValueChange={(values) => {
                          const { formattedValue, value, floatValue } = values;
                          this.calculateData("generalRepair", floatValue);
                        }}
                      />
                    </Col>
                    <Col className="gutter-row" span={6}>
                      <div style={{ textAlign: "right" }}>
                        <p>
                          <CurrencyFormat
                            style={{ marginBottom: 0 }}
                            value={getIntegerValueByKey(
                              payload,
                              "generalRepair.priceTotal"
                            )}
                            displayType={"text"}
                            decimalSeparator={","}
                            thousandSeparator={"."}
                            prefix={"Rp "}
                          />
                        </p>
                      </div>
                    </Col>
                  </Row>
                  <Row
                    gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                    justify="space-between"
                    align="middle"
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}>
                    <Col className="gutter-row" span={6}>
                      <p style={{ marginBottom: 0 }}>Body Repair</p>
                    </Col>
                    <Col className="gutter-row" span={6}>
                      {this.defaultValueContent(
                        getIntegerValueByKey(payload, "bodyRepair.odooPrice")
                      )}
                    </Col>
                    <Col className="gutter-row" span={6}>
                      <CurrencyFormat
                        style={{
                          border: "1px solid #d9d9d9",
                          borderRadius: "5px",
                          width: "100%",
                          margin: "2px 0",
                        }}
                        value={getIntegerValueByKey(
                          payload,
                          "bodyRepair.trustPrice"
                        )}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        prefix={"Rp "}
                        placeholder={"Rp 0"}
                        disabled={
                          rawData
                            ? rawData.isAgree || rawData.status !== "New"
                              ? true
                              : false
                            : true
                        }
                        onValueChange={(values) => {
                          const { formattedValue, value, floatValue } = values;
                          this.calculateData("bodyRepair", floatValue);
                        }}
                      />
                    </Col>
                    <Col className="gutter-row" span={6}>
                      <div style={{ textAlign: "right" }}>
                        <p>
                          <CurrencyFormat
                            style={{ marginBottom: 0 }}
                            value={getIntegerValueByKey(
                              payload,
                              "bodyRepair.priceTotal"
                            )}
                            displayType={"text"}
                            decimalSeparator={","}
                            thousandSeparator={"."}
                            prefix={"Rp "}
                          />
                        </p>
                      </div>
                    </Col>
                  </Row>
                  <Row
                    gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                    justify="space-between"
                    align="middle"
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}>
                    <Col className="gutter-row" span={6}>
                      <p style={{ marginBottom: 0 }}>Biaya Pajak STNK</p>
                    </Col>
                    <Col className="gutter-row" span={6}>
                      {this.defaultValueContent(
                        getIntegerValueByKey(
                          payload,
                          "biayaPajakSTNK.odooPrice"
                        )
                      )}
                    </Col>
                    <Col className="gutter-row" span={6}>
                      <CurrencyFormat
                        style={{
                          border: "1px solid #d9d9d9",
                          borderRadius: "5px",
                          width: "100%",
                          margin: "2px 0",
                        }}
                        value={getIntegerValueByKey(
                          payload,
                          "biayaPajakSTNK.trustPrice"
                        )}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        prefix={"Rp "}
                        placeholder={"Rp 0"}
                        disabled={
                          rawData
                            ? rawData.isAgree || rawData.status !== "New"
                              ? true
                              : false
                            : true
                        }
                        onValueChange={(values) => {
                          const { formattedValue, value, floatValue } = values;
                          this.calculateData("biayaPajakSTNK", floatValue);
                        }}
                      />
                    </Col>
                    <Col className="gutter-row" span={6}>
                      <div style={{ textAlign: "right" }}>
                        <p>
                          <CurrencyFormat
                            style={{ marginBottom: 0 }}
                            value={getIntegerValueByKey(
                              payload,
                              "biayaPajakSTNK.priceTotal"
                            )}
                            displayType={"text"}
                            decimalSeparator={","}
                            thousandSeparator={"."}
                            prefix={"Rp "}
                          />
                        </p>
                      </div>
                    </Col>
                  </Row>
                  <Row
                    gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                    justify="space-between"
                    align="middle"
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}>
                    <Col className="gutter-row" span={6}>
                      <p style={{ marginBottom: 0 }}>BBM Stock Unit</p>
                    </Col>
                    <Col className="gutter-row" span={6}>
                      {this.defaultValueContent(
                        getIntegerValueByKey(payload, "bbmStockUnit.odooPrice")
                      )}
                    </Col>
                    <Col className="gutter-row" span={6}>
                      <CurrencyFormat
                        style={{
                          border: "1px solid #d9d9d9",
                          borderRadius: "5px",
                          width: "100%",
                          margin: "2px 0",
                        }}
                        value={getIntegerValueByKey(
                          payload,
                          "bbmStockUnit.trustPrice"
                        )}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        prefix={"Rp "}
                        placeholder={"Rp 0"}
                        disabled={
                          rawData
                            ? rawData.isAgree || rawData.status !== "New"
                              ? true
                              : false
                            : true
                        }
                        onValueChange={(values) => {
                          const { formattedValue, value, floatValue } = values;
                          this.calculateData("bbmStockUnit", floatValue);
                        }}
                      />
                    </Col>
                    <Col className="gutter-row" span={6}>
                      <div style={{ textAlign: "right" }}>
                        <p>
                          <CurrencyFormat
                            style={{ marginBottom: 0 }}
                            value={getIntegerValueByKey(
                              payload,
                              "bbmStockUnit.priceTotal"
                            )}
                            displayType={"text"}
                            decimalSeparator={","}
                            thousandSeparator={"."}
                            prefix={"Rp "}
                          />
                        </p>
                      </div>
                    </Col>
                  </Row>
                  <Row
                    gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                    justify="space-between"
                    align="middle"
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}>
                    <Col className="gutter-row" span={6}>
                      <p style={{ marginBottom: 0 }}>Others</p>
                    </Col>
                    <Col className="gutter-row" span={6}>
                      {this.defaultValueContent(
                        getIntegerValueByKey(payload, "others.odooPrice")
                      )}
                    </Col>
                    <Col className="gutter-row" span={6}>
                      <CurrencyFormat
                        style={{
                          border: "1px solid #d9d9d9",
                          borderRadius: "5px",
                          width: "100%",
                          margin: "2px 0",
                        }}
                        value={getIntegerValueByKey(
                          payload,
                          "others.trustPrice"
                        )}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        prefix={"Rp "}
                        placeholder={"Rp 0"}
                        disabled={
                          rawData
                            ? rawData.isAgree || rawData.status !== "New"
                              ? true
                              : false
                            : true
                        }
                        onValueChange={(values) => {
                          const { formattedValue, value, floatValue } = values;
                          this.calculateData("others", floatValue);
                        }}
                      />
                    </Col>
                    <Col className="gutter-row" span={6}>
                      <div style={{ textAlign: "right" }}>
                        <p>
                          <CurrencyFormat
                            style={{ marginBottom: 0 }}
                            value={getIntegerValueByKey(
                              payload,
                              "others.priceTotal"
                            )}
                            displayType={"text"}
                            decimalSeparator={","}
                            thousandSeparator={"."}
                            prefix={"Rp "}
                          />
                        </p>
                      </div>
                    </Col>
                  </Row>
                  <Row
                    gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                    justify="space-between"
                    align="middle"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: 10,
                      marginBottom: 10,
                      marginLeft: -16,
                      marginRight: -16,
                    }}>
                    <Col className="gutter-row" span={12}>
                      <p
                        style={{
                          fontWeight: "bold",
                          marginBottom: 0,
                        }}>
                        Total Cost
                      </p>
                    </Col>
                    <Col className="gutter-row" span={12}>
                      <div style={{ textAlign: "right" }}>
                        <p
                          style={{
                            fontWeight: "bold",
                            marginBottom: 0,
                          }}>
                          <CurrencyFormat
                            style={{
                              width: "100%",
                              margin: "2px 0",
                            }}
                            value={getIntegerValueByKey(payload, "totalCost")}
                            thousandSeparator={"."}
                            decimalSeparator={","}
                            displayType={"text"}
                            prefix={"Rp "}
                          />
                        </p>
                      </div>
                    </Col>
                  </Row>
                  <Row
                    gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                    justify="space-between"
                    align="middle"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: 10,
                      marginBottom: 10,
                      marginLeft: -16,
                      marginRight: -16,
                    }}>
                    <Col className="gutter-row" span={12}>
                      <p
                        style={{
                          fontWeight: "bold",
                          marginBottom: 0,
                        }}>
                        Available Margin
                      </p>
                    </Col>
                    <Col className="gutter-row" span={12}>
                      <div style={{ textAlign: "right" }}>
                        <CurrencyFormat
                          style={{
                            width: "100%",
                            margin: "2px 0",
                          }}
                          value={getIntegerValueByKey(
                            payload,
                            "availableMargin"
                          )}
                          thousandSeparator={"."}
                          decimalSeparator={","}
                          displayType={"text"}
                          prefix={"Rp "}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row
                    gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                    style={{
                      marginTop: 10,
                      marginBottom: 10,
                      marginLeft: 0,
                      marginRight: 0,
                      display: "flex",
                      alignItems: "center",
                    }}>
                    <Col className="gutter-row" span={12}>
                      <div style={{ marginBottom: 5 }}>
                        Discounts - Subsidi DP
                      </div>
                      <Row
                        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}>
                        <Col className="gutter-row" span={10}>
                          <div style={{ display: "flex" }}>
                            <CurrencyFormat
                              style={{
                                border: "1px solid #d9d9d9",
                                borderRadius: 5,
                                width: "100%",
                                padding: "0 10px",
                              }}
                              value={getFloatValueByKey(
                                payload,
                                "discountSubsidiDP.discount"
                              )}
                              thousandSeparator={"."}
                              decimalSeparator={","}
                              disabled={true}
                              placeholder={"Diskon"}
                            />
                            <div
                              style={{
                                padding: 10,
                                marginLeft: -30,
                              }}>
                              %
                            </div>
                          </div>
                        </Col>
                        <Col className="gutter-row" span={14}>
                          <div style={{ display: "flex" }}>
                            <div
                              style={{
                                padding: 10,
                                backgroundColor: "#EAEAEA",
                                borderRadius: "5px 0px 0px 5px",
                              }}>
                              Rp.
                            </div>
                            <CurrencyFormat
                              style={{
                                border: "1px solid #d9d9d9",
                                borderRadius: "5px",
                                width: "100%",
                                padding: "0 10px",
                              }}
                              value={getIntegerValueByKey(
                                payload,
                                "discountSubsidiDP.priceTotal"
                              )}
                              thousandSeparator={"."}
                              decimalSeparator={","}
                              placeholder={"0"}
                              disabled={
                                rawData
                                  ? rawData.isAgree || rawData.status !== "New"
                                    ? true
                                    : false
                                  : true
                              }
                              onValueChange={(values) => {
                                const { formattedValue, value, floatValue } =
                                  values;
                                this.calculateData(
                                  "discountSubsidiDP",
                                  floatValue
                                );
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col className="gutter-row" span={12}>
                      <div style={{ marginBottom: 5 }}>Discounts</div>
                      <Row
                        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}>
                        <Col className="gutter-row" span={10}>
                          <div style={{ display: "flex" }}>
                            <CurrencyFormat
                              style={{
                                border: "1px solid #d9d9d9",
                                borderRadius: 5,
                                width: "100%",
                                padding: "0 10px",
                              }}
                              value={getFloatValueByKey(
                                payload,
                                "discount.discount"
                              )}
                              thousandSeparator={"."}
                              decimalSeparator={","}
                              disabled={true}
                            />
                            <div
                              style={{
                                padding: 10,
                                marginLeft: -30,
                              }}>
                              %
                            </div>
                          </div>
                        </Col>
                        <Col className="gutter-row" span={14}>
                          <div style={{ display: "flex" }}>
                            <div
                              style={{
                                padding: 10,
                                backgroundColor: "#EAEAEA",
                                borderRadius: "5px 0px 0px 5px",
                              }}>
                              Rp.
                            </div>
                            <CurrencyFormat
                              style={{
                                border: "1px solid #d9d9d9",
                                borderRadius: "0px 5px 5px 0px",
                                width: "100%",
                                padding: "0 10px",
                              }}
                              value={getIntegerValueByKey(
                                payload,
                                "discount.priceTotal"
                              )}
                              thousandSeparator={"."}
                              decimalSeparator={","}
                              disabled={true}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  <Row
                    gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                    justify="space-between"
                    align="middle"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: 10,
                      marginBottom: 10,
                      marginLeft: -16,
                      marginRight: -16,
                    }}>
                    <Col className="gutter-row" span={12}>
                      <p
                        style={{
                          fontWeight: "bold",
                          marginBottom: 0,
                        }}>
                        PROFIT
                      </p>
                    </Col>
                    <Col className="gutter-row" span={12}>
                      <div style={{ textAlign: "right" }}>
                        <p style={{ fontWeight: "bold" }}>
                          (
                          <CurrencyFormat
                            style={{
                              width: "100%",
                              margin: "2px 0",
                            }}
                            value={getFloatValueByKey(
                              payload,
                              "profit.profitPercent"
                            )}
                            thousandSeparator={"."}
                            decimalSeparator={","}
                            decimalScale={2}
                            displayType={"text"}
                          />{" "}
                          %)
                          <span style={{ fontWeight: "normal" }}>
                            <CurrencyFormat
                              style={{
                                width: "100%",
                                margin: "2px",
                              }}
                              value={getIntegerValueByKey(
                                payload,
                                "profit.priceTotal"
                              )}
                              thousandSeparator={"."}
                              decimalSeparator={","}
                              displayType={"text"}
                              prefix={"Rp "}
                            />
                          </span>
                        </p>
                        {payload.profit.profitPercent <=
                          payload.mProfitPercent &&
                        rawData &&
                        rawData.status === "New" ? (
                          <div
                            style={{
                              color: "red",
                              marginTop: -10,
                            }}>
                            Need GM Approval
                          </div>
                        ) : null}
                      </div>
                    </Col>
                  </Row>

                  <FormItem style={{ marginBottom: 0 }} label="Notes">
                    <p>{rawData ? rawData.salesNotes : "-"}</p>
                  </FormItem>

                  {rawData && rawData.status === "Reject" ? (
                    <FormItem
                      style={{ marginBottom: 0 }}
                      label="Rejected Notes">
                      <p>{rawData ? rawData.rejectedNotes : "-"}</p>
                    </FormItem>
                  ) : null}

                  {rawData && rawData.status === "SPK Reject" ? (
                    <FormItem
                      style={{ marginBottom: 0 }}
                      label="SPK Rejected Notes">
                      <p>{rawData ? rawData.spkNotes : "-"}</p>
                    </FormItem>
                  ) : null}
                </div>
              ) : null}
            </div>
          ) : null}
        </div>
      </div>
    );
  };

  render() {
    const { history } = this.props;
    const {
      rawData,
      payload,
      showModal,
      showModalConfirmation,
      showModalValidation,
      showModalDialog,
      showModalReject,
      isDefault,
      isPPN,
      isSourcing,
      isSelling,
      profit,
      modalCaption,
      isAgree,
      dataAccumulated,
    } = this.state;
    let areaName =
      _.get(rawData, "SalesProfile.SalesBranch.AreaBranch.name") || "-";
    let branchName = _.get(rawData, "SalesProfile.SalesBranch.branch") || "-";

    return (
      <div>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col
            className="gutter-row"
            span={
              (rawData && rawData.status.includes("New")) ||
              (rawData && rawData.status.includes("Waiting"))
                ? 24
                : 16
            }
            style={{ marginTop: 35 }}>
            <CarInformation rawData={rawData} />

            <Card title="Detail Pengajuan Diskon">
              <Spin
                tip="Sedang mengambil data pengajuan diskon"
                spinning={this.state.isLoading}>
                <Form>
                  <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={12}>
                      <Link to={"/home/e-approval/selling-system"}>
                        <p>Back to List</p>
                      </Link>
                    </Col>
                    <Col className="gutter-row" span={12}>
                      <h4 style={{ textAlign: "right" }}>
                        Stock Days:{" "}
                        {payload && payload.stockDays ? payload.stockDays : 0}
                      </h4>
                      <h4 style={{ textAlign: "right", fontWeight: "normal" }}>
                        Km:{" "}
                        <CurrencyFormat
                          value={getIntegerValueByKey(payload, "kilometer")}
                          displayType={"text"}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                        />
                      </h4>
                    </Col>
                  </Row>
                  <Row
                    gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                    style={{ marginBottom: 10 }}>
                    <Col span={12}>
                      <h4>Nama Salesman:</h4>
                      <p>
                        <span>
                          {rawData && rawData.SalesProfile
                            ? rawData.SalesProfile.name
                            : "-"}
                        </span>
                      </p>
                      <div>
                        <h4>Nama Unit:</h4>
                        <p>{rawData ? rawData.carName : "-"}</p>
                      </div>
                      <div>
                        <h4>No Polisi:</h4>
                        <p>{rawData ? rawData.licensePlate : "-"}</p>
                      </div>
                      <div>
                        <h4>Product Type:</h4>
                        <p>{rawData ? rawData.productType : "-"}</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <h4>Nama Area:</h4>
                      <p>
                        <span>{areaName}</span>
                      </p>
                      <div>
                        <h4>Nama Cabang:</h4>
                        <p>{branchName}</p>
                      </div>
                      <div>
                        <h4>Tanggal:</h4>
                        <p>
                          {" "}
                          {rawData
                            ? moment(rawData.createdAt).format("DD MMMM YYYY")
                            : "-"}
                        </p>
                      </div>
                    </Col>
                  </Row>

                  <div
                    style={{
                      borderRadius: 10,
                      backgroundColor: "#EFF2F5",
                      padding: 15,
                    }}>
                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                      <Col className="gutter-row" span={12}>
                        <div>
                          <h4>OTR</h4>
                          <h4>Sales Revenue</h4>
                          {rawData && rawData.productType != "Operational" && (
                            <h4>DPP</h4>
                          )}
                        </div>
                      </Col>
                      <Col className="gutter-row" span={12}>
                        <div style={{ textAlign: "right" }}>
                          <h4>
                            <CurrencyFormat
                              style={{ fontWeight: "normal" }}
                              value={getIntegerValueByKey(payload, "otr")}
                              displayType={"text"}
                              decimalSeparator={","}
                              thousandSeparator={"."}
                              prefix={"Rp "}
                            />
                          </h4>
                          <h4>
                            <CurrencyFormat
                              style={{ fontWeight: "normal" }}
                              value={getIntegerValueByKey(
                                payload,
                                "salesRevenue"
                              )}
                              displayType={"text"}
                              decimalSeparator={","}
                              thousandSeparator={"."}
                              prefix={"Rp "}
                            />
                          </h4>

                          {rawData && rawData.productType != "Operational" && (
                            <h4>
                              <CurrencyFormat
                                style={{ fontWeight: "normal" }}
                                value={getIntegerValueByKey(payload, "dpp")}
                                displayType={"text"}
                                decimalSeparator={","}
                                thousandSeparator={"."}
                                prefix={"Rp "}
                              />
                            </h4>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </div>

                  {this.calculationDetail()}
                  {rawData && rawData.productType != "Operational" && (
                    <AccumulatedGP dataAccumulated={dataAccumulated} />
                  )}

                  {rawData && rawData.status.includes("New") ? (
                    <Row type="flex" justify="end">
                      <Col>
                        <Button
                          htmlType="button"
                          disabled={isDefault}
                          style={{ margin: "0 15px" }}
                          onClick={() =>
                            this.setState({
                              showModalReject: true,
                              isAgree: false,
                            })
                          }>
                          {rawData && rawData.isAgree ? "Reject" : "Disagree"}
                        </Button>
                      </Col>
                      <Col>
                        <Button
                          htmlType="button"
                          type="primary"
                          disabled={isDefault}
                          onClick={() =>
                            this.setState({
                              showModalConfirmation: true,
                              isAgree: true,
                            })
                          }>
                          {rawData && rawData.isAgree
                            ? payload.profit.profitPercent <=
                              payload.mProfitPercent
                              ? "Request GM Approval"
                              : "Approve"
                            : "Agree"}
                        </Button>
                      </Col>
                    </Row>
                  ) : rawData &&
                    rawData.status === "SPK" &&
                    rawData.salesType !== "Operational" ? (
                    <Row type="flex" justify="end">
                      <Col>
                        <Button
                          htmlType="button"
                          type="primary"
                          onClick={() =>
                            this.setState({ showModalValidation: true })
                          }>
                          Validasi
                        </Button>
                      </Col>
                    </Row>
                  ) : null}
                </Form>
              </Spin>

              <ModalRejectApproval
                showModal={showModalReject}
                id={history.location.state.id}
                toggleShowModal={(value) =>
                  this.setState({ showModalReject: value })
                }
                actionModal={() =>
                  this.setState({
                    showModalReject: false,
                    showModalDialog: true,
                    modalCaption: "Request Successfully Rejected",
                  })
                }
              />

              <ModalValidationSPK
                showModal={showModalValidation}
                id={history.location.state.id}
                toggleShowModal={(value) =>
                  this.setState({ showModalValidation: value })
                }
                actionModal={() =>
                  this.setState({
                    showModalValidation: false,
                    showModalDialog: true,
                    modalCaption: "Request Successfully",
                  })
                }
              />

              <ModalConfirmation
                showModal={showModalConfirmation}
                title={"BOH Approval"}
                buttonText={
                  rawData && rawData.isAgree
                    ? payload &&
                      payload.profit.profitPercent <= payload.mProfitPercent
                      ? "Submit"
                      : "Approve"
                    : "Submit"
                }
                caption={
                  rawData && rawData.isAgree
                    ? `Apakah anda yakin untuk ${
                        payload &&
                        payload.profit.profitPercent <= payload.mProfitPercent
                          ? "request ke GM"
                          : "menyetujui"
                      } pengajuan ini?`
                    : `Apakah anda${
                        isAgree ? "" : " tidak"
                      } setuju dengan rincian data pengajuan ini?`
                }
                toggleShowModal={(value) =>
                  this.setState({ showModalConfirmation: value })
                }
                handleAction={() => this.handleAction(isAgree)}
              />

              <ModalDialog
                showModal={showModalDialog}
                caption={modalCaption}
                toggleShowModal={(value) => {
                  this.setState({ showModalDialog: value });
                  (rawData && rawData.isAgree) || !isAgree
                    ? this.props.history.push(`/home/e-approval/selling-system`)
                    : this.fetchData(rawData.id);
                }}
              />

              <ModalCreateSPK
                showModal={showModal}
                dataBooking={this.state.modalData}
                appraiserList={this.state.appraiserList}
                // fetchBooking={this.fetchBooking}
                // fetchAppraiser={this.fetchAppraiser}
                toggleShowModal={(value) => this.setState({ showModal: value })}
              />
            </Card>
          </Col>
          <AuditTrail rawData={rawData} />
        </Row>
      </div>
    );
  }
}

let mapStateToProps = ({ Auth }) => ({ Auth });

export default Form.create()(connect(mapStateToProps)(EApprovalBOHDetail));



// WEBPACK FOOTER //
// src/components/Dashboard/EApproval/EApprovalBOHDetail.js